/**
 * Avatar Service - Handles avatar-related API calls
 */

import { userServiceApi } from '@/services/api';

export interface Avatar {
  id: number;
  name: string;
  url: string;
}

export interface AvatarsApiResponse {
  avatars: Avatar[];
}

/**
 * Fetch all available avatars from the server
 * @returns Promise with avatars data
 */
export const getAvatars = async (): Promise<{
  success: boolean;
  data: Avatar[];
  message?: string;
}> => {
  console.log('🔄 [AvatarService] Starting to fetch avatars from API...');

  try {
    console.log('📤 [AvatarService] Making GET request to /user/avatars');
    const response = await userServiceApi.get<AvatarsApiResponse>('/user/avatars');

    console.log('📥 [AvatarService] Response received:', {
      success: true,
      dataLength: response.data?.avatars?.length || 0,
      message: 'Avatars fetched successfully'
    });

    console.log('✅ [AvatarService] Avatars fetched successfully:', response.data?.avatars || []);

    return {
      success: true,
      data: response.data?.avatars || [],
      message: 'Avatars retrieved successfully'
    };
  } catch (error) {
    console.error('🚨 [AvatarService] Error fetching avatars:', error);
    console.error('🚨 [AvatarService] Error details:', {
      name: error instanceof Error ? error.name : 'Unknown',
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined
    });

    return {
      success: false,
      data: [],
      message: 'Failed to connect to server'
    };
  }
};
